import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FaRegBuilding } from "react-icons/fa";
import imgdep from "../../Assets/ece11.jpg";
import SummaryApi from "../../common";
import CourseModal from "./CourseModal";

const AllCourses = () => {
  const [departments, setDepartments] = useState([]);
  const [courses, setCourses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const departmentsPerPage = 3;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editDepartment, setEditDepartment] = useState(null);

  useEffect(() => {
    // Fetching department data
    const fetchDepartments = async () => {
      try {
        const response = await fetch(SummaryApi.getAllDepartment.url);
        const result = await response.json();

        if (result.status) {
          // Set the department data in state
          setDepartments(result.data);
        } else {
          console.error("Failed to fetch departments");
        }
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };

    // Fetching course data
    const fetchCourses = async () => {
      try {
        const response = await fetch(SummaryApi.getAllCourses.url);
        const result = await response.json();

        if (result.status) {
          // Map the fetched data into your state format
          const fetchedCourses = result.data.map((course) => ({
            id: course.course_id,
            name: course.course_name,
            departmentId: course.department_id,
            courseLevel: course.course_level,
            courseType: course.course_type,
            description: course.description,
            tuitionFee: course.tuition_fee,
            maxStudents: course.max_students,
            credits: course.credits,
            image: course.course_image
              ? `${SummaryApi.getCourseImages.url}${course.course_image
                  .split("/")
                  .pop()}`
              : imgdep,
            isactive: course.is_active,
          }));
          setCourses(fetchedCourses);
        } else {
          console.error("Failed to fetch courses");
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchDepartments();
    fetchCourses();
  }, []);

  // Find the department name by department_id
  const getDepartmentName = (departmentId) => {
    const department = departments.find(
      (dept) => dept.department_id.toString() === departmentId.toString()
    );
    return department ? department.department_name : "Unknown Department";
  };

  const indexOfLastDepartment = currentPage * departmentsPerPage;
  const indexOfFirstDepartment = indexOfLastDepartment - departmentsPerPage;
  const currentDepartments = courses.slice(
    indexOfFirstDepartment,
    indexOfLastDepartment
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(courses.length / departmentsPerPage);

  // Open modal to edit department
  const handleEdit = (department) => {
    setEditDepartment(department);
    setIsModalOpen(true);
  };
  // Handle input change in modal
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditDepartment((prev) => ({ ...prev, [name]: value }));
  };
// Handle saving changes to the department
const handleSave = async () => {
  try {
    const response = await fetch(SummaryApi.updateCourse.url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        course_id: editDepartment.id,
        department_id: editDepartment.departmentId,
        course_name: editDepartment.name,
        credits: editDepartment.credits,
        description: editDepartment.description,
        max_students: editDepartment.maxStudents,
        course_level: editDepartment.courseLevel,
        course_type: editDepartment.courseType,
        tuition_fee: editDepartment.tuitionFee,
        course_image: editDepartment.image.split(",")[1], // If base64
        is_active: editDepartment.isactive,
      }),
    });

    const result = await response.json();

    if (result.status) {
      // Update the course in the local state if the update is successful
      setCourses((prevCourses) =>
        prevCourses.map((course) =>
          course.id === editDepartment.id ? editDepartment : course
        )
      );
      closeModal(); // Close the modal after saving
    } else {
      console.error("Failed to update course");
    }
  } catch (error) {
    console.error("Error saving course:", error);
  }
};


  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0]; // Get the selected file
    if (file) {
      const reader = new FileReader(); // Create a FileReader to read the file
      reader.onloadend = () => {
        // Set the image data URL to the state
        setEditDepartment((prevState) => ({
          ...prevState,
          image: reader.result, // This will be the base64 URL of the image
        }));
      };
      reader.readAsDataURL(file); // Read the file as a data URL
    }
  };

  return (
    <div className="container">
      <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-3xl font-semibold mb-4 sm:mb-5 md:mb-6 text-center sm:text-left">
        Courses
      </h1>

      <nav className="text-gray-600 mb-4">
        <ol className="flex flex-wrap items-center space-x-2 text-sm sm:text-base md:text-lg lg:text-xl xl:text-xl">
          <li>
            <Link to="/dashboard" className="hover:text-[#ffa404]">
              Home
            </Link>
          </li>
          <li className="text-[#ffa404]">
            <MdKeyboardArrowRight size={25} />
          </li>
          <li className="text-[#ffa404]">
            <Link to="/AllCourses" className="hover:text-[#ffa404]">
              All Courses
            </Link>
          </li>
        </ol>
      </nav>

      <div className="bg-white shadow-md rounded-lg p-6 mt-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center sm:text-left">
          All Courses
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {currentDepartments.map((course) => (
            <div
              key={course.id}
              className="bg-gray-50 border rounded-lg p-4 flex flex-col"
            >
              <img
                src={course.image}
                alt={course.name}
                className="w-96 h-56 rounded-[15px] mt-4"
              />
              <div className="flex justify-between">
                <h3 className="text-lg font-semibold text-gray-800 mb-1 text-center">
                  {course.name}
                </h3>
                <strong className="text-gray-600">
                  Credits: {course.credits}
                </strong>
              </div>
              <div className="flex flex-col gap-1 mb-3 flex-grow">
                <div className="p-3">
                  <p className="text-gray-600">
                    Department: {getDepartmentName(course.departmentId)}
                  </p>
                  <p className="text-gray-600">
                    Course Level: {course.courseLevel}
                  </p>
                  <p className="text-gray-600">
                    Course Type: {course.courseType}
                  </p>
                  <p className="text-gray-600">
                    Max Students: {course.maxStudents}
                  </p>
                  <div className="flex justify-between mt-2">
                    <p className="text-gray-600 text-left">
                      Description:{" "}
                      {course.description.length > 50
                        ? course.description.slice(0, 50) + "..."
                        : course.description}
                    </p>
                    <strong className="text-gray-600 text-right">
                      ₹{course.tuitionFee}
                    </strong>
                  </div>
                </div>
              </div>
              <div className="p-2 mt-auto flex justify-between">
                <button
                  onClick={() => handleEdit(course)}
                  className="bg-white text-orange-500 border-2 border-orange-500 px-5 py-3 rounded-md transition-all duration-1000 ease-in-out hover:bg-gradient-to-r hover:from-orange-300 hover:via-orange-500 hover:to-orange-700 hover:text-white font-bold"
                >
                  EDIT
                </button>
                <p
                  className={`mt-2 p-2 rounded-md text-center ${
                    course.isactive === "1"
                      ? "bg-green-500 text-white"
                      : "bg-red-500 text-white"
                  }`}
                >
                  {course.isactive ? "Active" : "Inactive"}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-end mt-6">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="bg-blue-500 text-white p-2 rounded-md disabled:opacity-50"
          >
            Prev
          </button>
          <span className="mx-2 text-gray-800">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="bg-blue-500 text-white p-2 rounded-md disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>

      {isModalOpen && (
        <CourseModal
          isModalOpen={isModalOpen}
          editDepartment={editDepartment}
          handleInputChange={handleInputChange}
          handleSave={handleSave}
          closeModal={closeModal}
        />
      )}
    </div>
  );
};

export default AllCourses;
